// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__1OZpz","content":"Dashboard_content__3YvoR","fadeIn":"Dashboard_fadeIn__Zha0K","fadeOut":"Dashboard_fadeOut__14FK9"};